import React, { Component } from 'react'
import { Header } from './Header'
import { Footer } from './Footer'
import { Card, Row, Col, Container } from 'react-bootstrap'
import img71 from '../EquipoMedico/img71.jpg'
import img72 from '../EquipoMedico/img72.jpg'
import img73 from '../EquipoMedico/img73.jpg'

export class FirstAids extends Component {
    render() {
        const aidItems = [
            { img: img71, title: "Briefcases and Backpacks" },
            { img: img72, title: "Medical Kits & Accessories" },
            { img: img73, title: "First Aid Supplies" }
        ];

        return (
            <div>
                <Header />
                <Container fluid className="px-5">
                    <br />
                    <Row>
                        <Col className="text-center">
                            <h1>First Aid</h1>
                        </Col>
                    </Row>
                    <br />

                    {/* Distribución de 3 columnas para un equilibrio visual perfecto */}
                    <Row className="justify-content-center g-4">
                        {aidItems.map((item, idx) => (
                            <Col key={idx} xs={12} md={6} lg={4}>
                                <Card className="shadow-sm border-0 text-center h-100">
                                    <Card.Body className="p-3">
                                        <Card.Img 
                                            variant="top" 
                                            src={item.img} 
                                            style={{ width: '100%', height: 'auto', objectFit: 'contain' }} 
                                        />
                                    </Card.Body>
                                    <Card.Footer className="bg-white border-0">
                                        <Card.Title style={{ fontSize: '1.4rem' }}>{item.title}</Card.Title>
                                    </Card.Footer>
                                </Card>
                            </Col>
                        ))}
                    </Row>
                    <br />
                </Container>
                <Footer />
            </div>
        )
    }
}